export default "__VITE_ASSET__3155510b__"